<template>
  <div>
    <div v-if="items.length == 0">
      <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <v-icon size="100" dark>fas fa-barcode</v-icon>
            <div class="font-weight-thin">KOSONG</div>
            <h1 class="display-1 font-weight-thin mb-4">Nantikan !</h1>
            <h4 class="subheading">Nantikan produk - produk terbaru dari para pedagang !</h4>
          </v-col>
        </v-row>
      </v-parallax>
    </div>
    <v-container>
      <v-row>
        <v-flex v-for="item in items" :key="item.title" xs4 md3 lg2>
          <div>
            <v-card shaped raised class="mx-1 mb-1">
              <v-img
                @click="detailProduct(item.idbarang)"
                :src="getImageUrl(item.gambar)"
                class="white--text align-end"
                width="auto"
                max-height="135"
                centered
              ></v-img>
              <v-card height="1" class="mt-3" color="black"></v-card>
              <v-card-actions>
                <v-row>
                  <v-col>
                    <div class="item-title p-0">
                      <b>{{item.nama_item}}</b>
                    </div>
                    <div class="item-price">
                      <b>{{item.harga | currency}}</b>
                    </div>
                    <div class="item-toko">{{item.nama_toko}}</div>

                    <!-- <div class="item-toko">
                      <b>{{ item.nama_toko }}</b>
                    </div>-->
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </v-flex>
      </v-row>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      userid: localStorage.getItem("user_id"),
      overlay: false
    };
  },
  mounted() {
    this.getProduct();
  },
  computed: {
    screen() {
      var x = screen.width;
      if (x < 576) {
        x = 4;
      } else if (x > 576) {
        x = 3;
      }
      return x;
    }
  },
  methods: {
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    },
    detailProduct(id) {
      this.$router.push("/detail/" + id);
    },
    getProduct() {
      this.overlay = true;
      if (this.userid != null) {
        fetch(
          "http://meridinet.saebo.id:2082/Login/api/tampil/id/" + this.userid
        )
          .then(response => response.json())
          .then(data => {
            this.items = data.filter(d => d.idkategori == 5);

            this.overlay = false;
          });
      } else {
        fetch("http://meridinet.saebo.id:2082/Login/api/tampil/")
          .then(response => response.json())
          .then(data => {
            this.items = data.filter(d => d.idkategori == 5);

            this.overlay = false;
          });
      }
    }
  }
};
</script>
<style scoped>
.item-toko {
  font-size: 85%;
  white-space: nowrap;
  width: 100%;
  font-weight: 300;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-title {
  font-size: 100%;
  width: 100%;
  height: 45px;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  margin-bottom: 0% !important;
}
.item-price {
  color: red;
  margin-bottom: 0% !important;
  font-size: 85%;
}
.all-produk {
  padding: 0px !important;
  margin-top: 5px;
}
@media only screen and (max-width: 600px) {
  .item-title {
    font-size: 85%;
    width: 100px;
    height: 40px;
    overflow: hidden;
    white-space: wrap;
    text-overflow: ellipsis;
    margin-bottom: 0% !important;
  }
  .item-price {
    color: red;
    margin-bottom: 0% !important;
    font-size: 85%;
  }
  .all-produk {
    padding: 0px !important;
    margin-top: 5px;
  }
}
</style>
